import { FlexProps, Td } from '@televet/kibble-ui/build/chakra';
import React from 'react';

type TaskTableColumnProps = Pick<FlexProps, 'minWidth' | 'maxWidth' | 'borderRightWidth' | 'alignContent' | 'pr'> & {
  children: React.ReactNode;
};

export const TaskTableColumn = ({ children, ...props }: TaskTableColumnProps): JSX.Element => {
  return (
    <Td
      px={4}
      py={4}
      alignContent="baseline"
      borderRightWidth="1px"
      borderBottomWidth="1px"
      borderColor="border.default"
      {...props}
    >
      {children}
    </Td>
  );
};
